import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const nederlandseSpoorwegen = defineConnector({
  identifier: "nederlandseSpoorwegen",
  name: "Nederlandse Spoorwegen",
  tagLine: "Dutch rail departures, disruptions, and stations",
  keywords: "ns dutch railways reisinformatie trein station storing",
  logo,
  protocol: "http",
  tags: ["data", "travel"],
  defaultUrlPattern: () => domainToRegex("gateway.apiportal.ns.nl"),
  auth: (app) =>
    headerAuth([
      {
        name: "Ocp-Apim-Subscription-Key",
        value: app.secret.subscriptionKey,
      },
    ]),
  steps: [
    {
      title: "Subscribe to a data product",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at the [**NS API portal**](https://apiportal.ns.nl/), then subscribe to a product — **Reisinformatie** covers departures, arrivals, disruptions, and stations. Your profile page reveals the subscription’s primary key.",
        },
      ],
    },
    {
      title: "Copy and paste the subscription key into the field below",
      items: [
        {
          kind: "input",
          label: "Subscription key",
          required: true,
          target: { kind: "secrets", field: "subscriptionKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://gateway.apiportal.ns.nl/reisinformatie-api/api/v2/stations",
  },
});
